import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
const badgeVariants = cva('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', {
  variants: {
    variant: {
      default: 'bg-surface-200 text-text-primary',
      primary: 'bg-brand-100 text-brand-800',
      secondary: 'bg-surface-100 text-text-secondary',
      success: 'bg-success-100 text-success-800',
      warning: 'bg-warning-100 text-warning-800',
      error: 'bg-error-100 text-error-800',
      outline: 'border border-border text-text-secondary'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}
export const Badge = ({
  className,
  variant,
  ...props
}: BadgeProps) => {
  return <div className={badgeVariants({
    variant,
    className
  })} {...props} data-id="element-176" />;
};